import { Injectable } from '@angular/core';
import { HttpService, SmBaseService, CacheService } from '../../core';
import { Observable } from 'rxjs';
import { of } from 'rxjs';
import { tap, share } from 'rxjs/operators';

export class CategoryNode implements CategoryModel {
	id: number = 0;
	name: string = '';
	parentId: number = 0;
	hasChildren: boolean = false;
	parent?: CategoryNode = null;
	children: CategoryNode[] = [];
}

@Injectable()
export class CategoryService extends SmBaseService {
	private _parentObservable: Observable<CategoryModel[]> = null;
	private _observable: Observable<CategoryModel> = null;

	constructor(http: HttpService, private _cache: CacheService) {
		super(http, 'category');
	}

	/**
	 * Returns the categories for given parent category id or root categories, when parent category is not set.
	 * @param parentId The parent category identifier.
	 */
	getCategories(parentId?: number): Observable<CategoryModel[]> {
		const key = 'category:parent:' + parentId;
		if (this._cache.has(key)) {
			return of(this._cache.get(key) as CategoryModel[]);
		}

		if (this._parentObservable != null) {
			return this._parentObservable;
		}

		let params: { [key: string]: string } = {};
		if (parentId != null) {
			params['parentId'] = '' + parentId;
		}

		this._parentObservable = this
			._getAs<CategoryModel[]>('', { params: params })
			.pipe(tap(val => {
				this._cache.set(key, val);

				val.forEach(c => {
					this._cache.set('category:' + c.id, c);
				});

				this._parentObservable = null;

				return val;
			}))
			.pipe(share());

		return this._parentObservable;
	}

	/**
	 * Returns the category for given identifier.
	 * @param id The category identifier
	 */
	getCategory(id: number): Observable<CategoryModel> {
		const key = 'category:' + id;
		if (this._cache.has(key)) {
			return of(this._cache.get(key) as CategoryModel);
		}

		if (this._cache.has(key)) {
			return of(this._cache.get(key) as CategoryModel);
		}

		if (this._observable != null) {
			return this._observable;
		}

		this._observable = this
			._getAs<CategoryModel>(id)
			.pipe(tap(val => {
				this._cache.set(key, val);
				this._observable = null;
				return val;
			}))
			.pipe(share());

		return this._observable;
	}

	/**
	 * Returns identifiers of the ancestors of category with provided identifier.
	 * Requested category identifier is included in result.
	 * @param id The category identifier.
	 */
	getCategoryPath(id: number): Observable<number[]> {
		return this._getAs<number[]>(id + '/path');
	}
}

export interface CategoryModel {
	id: number;
	name: string;
	parentId: number;
	hasChildren: boolean;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/shared/services/category.service.ts